import Vue from 'vue'
import ElementUI from 'element-ui';
Vue.use(ElementUI);
//私有属性，只在当前文件可用
const showMessage = Symbol('showMessage')
export default class domMessage{
    success(options,single = true){
        this[showMessage]('success',options,single)
    }
    warning(options,single = true){
        this[showMessage]('warning',options,single)
    }
    info(options,single = true){
        this[showMessage]('info',options,single)
    }
    error(options,single = true){
        this[showMessage]('error',options,single)
    }
    [showMessage](type,options,single){
        if(single){
            if(document.getElementsByClassName('el-message').length === 0){
                Vue.prototype.$message[type](options)
            }
        }else{
            Vue.prototype.$message[type](options)
        }
    }
}